<template>
  <q-page class="container" padding>
    <div class="row col-12">
      <p class="text-h6 text-brand-5 text-weight-bold">Movimento de Estoque</p>
    </div>

      <div class="row justify-end q-mb-md">
        <q-checkbox v-model="zerados" label="Remover Zerados" size="md" />
      </div>

    <section v-if="rows2.length != 0" class="q-mt-sm">
      <q-table
        flat
        :title="'Lotes'"
        table-header-class="bg-accent text-width-bold"
        :rows="rows2"
        :loading="disable"
        dense
        :columns="columns2"
        color="primary"
        title-class="text-brand-5 text-weight-bold"
        v-model:pagination="pagination2"
        class="q-mt-md tabela-tamanho-fixo"
        row-key="name"
        hide-pagination
        @request="handleRequest2"
      >

        <template #body-cell-imagem="props">
          <q-td>
            <q-img
              :src="props.row.imagem"
              style="max-width: 300px; height: 70px"
              fit="contain"
            >
            </q-img>
          </q-td>
        </template>
        <template #body-cell-movimento="props">
          <q-td>
            <q-btn
              class="q-mt-lg"
              color="positive"
              dense
              round
              icon="trending_up"
              @click="movimento(props.row.id_produto)"
            />
          </q-td>
        </template>
        <template #body-cell-data="props">
          <q-td>
            <span v-if="props.row">{{
              props.row.data.split(" ")[0].split("-").reverse().join("/")
            }}</span>
            <span v-if="props.row" class="q-ml-sm">{{
              props.row.data.split(" ")[1]
            }}</span>
          </q-td>
        </template>
      </q-table>
      <div class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination2.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber2"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </section>

    <div class="row q-mt-lg justify-end">
      <q-btn label="Exportar" color="primary" dense @click="exportar" />
    </div>
    <section class="q-mt-sm">
      <q-table
        flat
        :title="'Movimentos' + ' ' + total"
        table-header-class="bg-accent text-width-bold"
        :rows="rows"
        dense
        :loading="disable"
        :columns="columns"
        color="primary"
        title-class="text-brand-5 text-weight-bold"
        v-model:pagination="pagination"
        class="q-mt-md tabela-tamanho-fixo"
        row-key="name"
        hide-pagination
        @request="handleRequest"
      >
        <template #body-cell-imagem="props">
          <q-td>
            <q-img
              :src="props.row.imagem"
              style="max-width: 300px; height: 70px"
              fit="contain"
            >
            </q-img>
          </q-td>
        </template>
        <template #body-cell-movimento="props">
          <q-td>
            <q-btn
              class="q-mt-lg"
              color="positive"
              dense
              round
              icon="trending_up"
              @click="movimento(props.row.id_produto)"
            />
          </q-td>
        </template>
        <template #body-cell-data="props">
          <q-td>
            <span v-if="props.row">{{
              props.row.data.split(" ")[0].split("-").reverse().join("/")
            }}</span>
            <span v-if="props.row" class="q-ml-sm">{{
              props.row.data.split(" ")[1]
            }}</span>
          </q-td>
        </template>
        <template #body-cell-id_transacao="props">
          <q-td>
            <span 
              v-if="props.row.id_transacao && isClickableTransaction(props.row.tipo_transacao)"
              class="text-primary cursor-pointer text-weight-medium"
              style="text-decoration: underline"
              @click="navigateToDetail(props.row.tipo_transacao, props.row.id_transacao)"
            >
              {{ props.row.id_transacao }}
            </span>
            <span v-else>
              {{ props.row.id_transacao }}
            </span>
          </q-td>
        </template>
      </q-table>
      <div class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </section>
  </q-page>
</template>

<script>
const columns2 = [
  {
    name: "lote",
    label: "Lote",
    field: "lote",
    align: "left",
  },
  {
    name: "data_validade",
    label: "Vencimento",
    field: (row) => row.data_validade.split("-").reverse().join("/"),
    align: "left",
  },
  {
    name: "quantidade",
    label: "Estoque",
    field: (row) =>
      row.quantidade != null ? Number(row.quantidade).toFixed(2) : "",
    align: "left",
  },
  {
    name: "tipo_transacao",
    label: "R$ Unit.",
    field: (row) =>
      row.preco_produto != null ? Number(row.preco_produto).toFixed(2) : "",
    align: "left",
  },
  {
    name: "valor_lote",
    label: "Total",
    field: (row) =>
      row.valor_lote != null ? Number(row.valor_lote).toFixed(2) : "",
    align: "left",
  },
];

const columns = [
  {
    name: "codigo_produto",
    label: "Código",
    field: (row) => {
      let result = row.codigo_produto || '';
      if (row.batch) {
        result += ' LOTE: ' + row.batch;
      }
      return result;
    },
    align: "left",
  },
  {
    name: "produto",
    label: "Produto",
    field: "produto",
    align: "left",
  },
  {
    name: "id_transacao",
    label: "ID Transação",
    field: "id_transacao",
    align: "left",
  },
  {
    name: "tipo_transacao",
    label: "Tipo Transação",
    field: "tipo_transacao",
    align: "left",
  },
  {
    name: "tipo",
    label: "Movimento",
    field: "tipo",
    align: "left",
  },
  {
    name: "saldo_inicial",
    label: "Saldo Inicial",
    field: "saldo_inicial",
    align: "left",
  },
  {
    name: "quantidade_movimentada",
    label: "Quantidade",
    field: "quantidade_movimentada",
    align: "left",
  },
  {
    name: "saldo_final",
    label: "Saldo Final",
    field: "saldo_final",
    align: "left",
  },
  {
    name: "data",
    label: "Data",
    field: "data",
    align: "left",
  },
];

import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { ref, computed, watch, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";

export default {
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const id = route.params.id;
    const rows = ref([]);
    const quasar = useQuasar();
    const disable = ref(true);
    const total = ref("");
    const unidadeDefault = ref("");
    const zerados = ref(true);
    const rows2 = ref([]);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 15,
    });

    const pagination2 = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 5,
    });

    const getDados = async (page = 0, rowsPerPage = 15) => {
      try {
        let response = await store.dispatch("ind/getEstoqueMovimento", {
          vendor_id: unidadeDefault.value.id,
          produto_id: id,
          page: page,
          perPage: rowsPerPage,
        });

        rows.value = response.data.result.data;

        disable.value = false;
      } catch (error) {
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const getLotes = async (page = 0, rowsPerPage = 5) => {
      try {
        let response = await store.dispatch("ind/getLotes", {
          vendor_id: unidadeDefault.value.id,
          produto_id: id,
          remover_zerados: zerados.value ? 1 : 0,
          page: page,
          perPage: rowsPerPage,
        });

        rows2.value = response.data.resultado.data;

        pagination2.value.page = response.data.resultado.current_page;
        pagination2.value.rowsNumber = response.data.resultado.total;
        pagination2.value.rowsPerPage = response.data.resultado.per_page;

        disable.value = false;
      } catch (error) {
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const exportar = async () => {
      try {
        await store.dispatch("ind/exportarEstoqueMovimento", {
          vendor_id: unidadeDefault.value.id,
          produto_id: id,
          page: pagination.value.page,
          perPage: pagination.value.rowsPerPage,
        });

        quasar.notify({
          message: "Exportado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        quasar.notify({
          message: "Erro a o exportar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const getUnidade = async () => {
      if (!store.state.org.unidadeData) {
        return;
      }
      unidadeDefault.value = await store.state.org.unidadeData;
      await getDados();
      await getLotes();
    };
    onMounted(getUnidade);

    const handleRequest = async () => {
      getDados(pagination.value.page, pagination.value.rowsPerPage);
    };

    const handleRequest2 = async () => {
      getLotes(pagination2.value.page, pagination2.value.rowsPerPage);
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => pagination2.value.page,
      () => {
        disable.value = true;
        handleRequest2();
      }
    );

    watch(
      () => zerados.value,
      () => {
        disable.value = true;
        handleRequest2();
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        if (store.state.org.unidadeData == null) {
          return;
        }
        unidadeDefault.value = store.state.org.unidadeData;
      }
    );

    const isClickableTransaction = (tipoTransacao) => {
      const clickableTypes = ['Voucher', 'Troca produto', 'Transferencia', 'Nota Fiscal', 'Inventario'];
      return clickableTypes.includes(tipoTransacao);
    };

    const navigateToDetail = (tipoTransacao, idTransacao) => {
      try {
        if (tipoTransacao === 'Voucher') {
          router.push({ name: 'requisicao-detalhe', params: { requisicaoId: idTransacao } });
        } else if (tipoTransacao === 'Troca produto') {
          router.push({ name: 'ajuste-estoque-novo' });
        } else if (tipoTransacao === 'Transferencia') {
          router.push({ name: 'transferencia-detalhe', params: { transferenciaId: idTransacao } });
        } else if (tipoTransacao === 'Nota Fiscal') {
          router.push({ name: 'nf-editar', params: { notaId: idTransacao } });
        } else if (tipoTransacao === 'Inventario') {
          router.push({ name: 'inventario-novo', params: { id: idTransacao } });
        } 
      } catch (error) {
        quasar.notify({
          message: "Erro ao navegar para o detalhe",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {},
            },
          ],
        });
      }
    };

    return {
      rows,
      columns,
      pagination,
      disable,
      getDados,
      handleRequest,
      exportar,
      total,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      pagesNumber2: computed(() =>
        Math.ceil(pagination2.value.rowsNumber / pagination2.value.rowsPerPage)
      ),
      zerados,
      pagination2,
      handleRequest2,
      columns2,
      rows2,
      isClickableTransaction,
      navigateToDetail,
    };
  },
};
</script>

<style></style>
